import React from 'react';
import { useAITTheme } from '../ui/theme';

const TripsPlaneIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
      <path
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        d="M385.35,477.75h-36.96c-11.09,0-18.48-7.39-18.48-18.48v-18.48h-147.83v18.48c0,11.09-7.39,18.48-18.48,18.48h-36.96c-11.09,0-18.48-7.39-18.48-18.48v-18.48h-18.48c-11.09,0-18.48-7.39-18.48-18.48V108.17c0-40.65,33.26-73.92,73.92-73.92h221.75c40.65,0,73.92,33.26,73.92,73.92v314.14c0,11.09-7.39,18.48-18.48,18.48h-18.48v18.48c0,11.09-7.39,18.48-18.48,18.48ZM108.79,256h294.42v-110.87H108.79v110.87ZM348.39,329.92c-14.78,0-27.72,12.94-27.72,27.72s12.94,27.72,27.72,27.72,27.72-12.94,27.72-27.72-12.94-27.72-27.72-27.72ZM163.61,329.92c-14.78,0-27.72,12.94-27.72,27.72s12.94,27.72,27.72,27.72,27.72-12.94,27.72-27.72-12.94-27.72-27.72-27.72Z"
      />
    </svg>
  );
};

export default TripsPlaneIcon;
